export const ANIMATION_NAMES = [
  'fade-in',
  'fade-up',
  'fade-down',
  'fade-left',
  'fade-right',
  'scale-in',
  'scale-half',
  'shutter-down',
  'zoom-in',
  'box-drop',
] as const;

export type AnimationName = (typeof ANIMATION_NAMES)[number];

export type AnimationVars = {
  opacity?: number
  x?: number
  y?: number
  yPercent?: number
  scale?: number
  clipPath?: string
  overflow?: string
};

export type AnimationPreset = {
  from: AnimationVars
  to: AnimationVars
};

export type ElementAnimationConfig = {
  names: AnimationName[]
  duration: number
  delay: number
  ease: string | null
};

export type RootAnimationConfig = {
  inView: boolean
  threshold: number
};

export const DEFAULT_DURATION = 0.6;
export const DEFAULT_DELAY = 0;
export const DEFAULT_EASE = 'power2.out';
export const DEFAULT_VIEW_THRESHOLD_PERCENT = 15;

// Extends the observer's viewport downward by this share of its height, so a
// block starts animating while it is still approaching from below the fold
// instead of only once it is well inside view. Higher = animations start earlier.
export const VIEW_TRIGGER_MARGIN_PERCENT = 20;

export const SELECTOR_ROOT = '.js-animate';
export const SELECTOR_TARGET = '[data-animate]';

export const DATA_ANIMATE = 'data-animate';
export const DATA_DURATION = 'data-animate-duration';
export const DATA_DELAY = 'data-animate-delay';
export const DATA_EASE = 'data-animate-ease';
export const DATA_PLAYED = 'data-animate-played';
export const DATA_INVIEW = 'data-animate-inview';
export const DATA_THRESHOLD = 'data-animate-threshold';

const animationNameSet = new Set<string>(ANIMATION_NAMES);

export function isAnimationName(value: string): value is AnimationName {
  return animationNameSet.has(value);
}
